// src/components/dentally/DentallyPractitionerMappingContent.jsx
//
// Inline host of the existing practitioner mapping tool
// (DentallyPractitionerSyncWizard). Loads the current practice's CRM users
// explicitly rather than assuming Integration settings already populated Redux.
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { dispatch, useSelector } from '../../redux/store';
import { getPracticeUserList } from '../../redux/slices/practiceUser';
import DentallyPractitionerSyncWizard from './DentallyPractitionerSyncWizard';

export default function DentallyPractitionerMappingContent({ practiceId }) {
  const loadedPracticeId = useSelector((state) => state.practiceUser?.loadedPracticeId);
  useEffect(() => {
    if (practiceId && String(loadedPracticeId) !== String(practiceId)) {
      dispatch(getPracticeUserList(practiceId, 0, [], { force: true }));
    }
  }, [practiceId, loadedPracticeId]);
  return <DentallyPractitionerSyncWizard inline practiceId={practiceId} />;
}

DentallyPractitionerMappingContent.propTypes = {
  practiceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
